import React from 'react';

const AppError = () => {
    return (
        <div className="page-error p-4">
            <h1>500</h1>
            <h2>Sorry, something's gone wrong.</h2>
            <p>
                If this keeps happening, please submit a ticket via our{' '}
                <a target="_blank" rel="noopener noreferrer" href="https://support.passport.inaudio.com/support/home">
                    support portal
                </a>
                .
            </p>
        </div>
    );
};

export default AppError;
